import React from "react";
import MobilePage from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import { usePictureSets } from "../../../hooks/usePictureSets";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useFullscreenImage } from "@/react/Webshop/Mobile/hooks/useFullscreenImage";
import FullscreenImageDialog from "@/react/Webshop/Mobile/Components/FullscreenImageDialog";
import EpmsImage from "@/react/components/Common/EpmsImage";
import BottomBar from "@/react/Webshop/Mobile/Components/BottomBar";
import useCopyrightDialog from "@/react/Webshop/hooks/useCopyrightDialog";
import { useTheme } from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    // Note: Have to be bigger than the fixed next button
    paddingBottom: `calc(48px + ${theme.spacing(2)})`,
  },
  headerSection: {
    marginBottom: theme.spacing(2),
  },
  newPictureSet: {
    color: theme.palette.primary.dark,
    textAlign: "center",
    fontSize: "15px",
    fontWeight: "bold",
  },

  jobName: {
    color: theme.palette.primary.dark,
    textAlign: "center",
    fontStyle: "italic",
    fontSize: "15px",
    fontWeight: "normal",
    marginTop: "2px",
  },
  list: {
    width: "100%",
    overflow: "auto",
    alignItems: "center",
    listStyle: "none",
    margin: 0,
    padding: 0,
    flexGrow: 1,
    display: "flex",
  },
  listItem: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& > img": {
      maxWidth: "100%",
      maxHeight: "100%",
      objectFit: "contain",
      backgroundColor: "white",
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  newSetText: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    display: "inline-block",
    padding: "3px 10px 3px 10px",
    marginLeft: "-40px",
    marginBottom: theme.spacing(2),
  },
}));

const NewPictureSet = () => {
  const { isLoaded, currentPictureSet } = usePictureSets();
  const classes = useStyles();
  const { open, fullscreenImage, origin, openImage, closeImage } =
    useFullscreenImage();
  const { getCopyrightTriggerProps, copyrightDialog } = useCopyrightDialog();
  const theme = useTheme();
  console.log("Found picture set ", currentPictureSet, isLoaded);

  if (!isLoaded) {
    return (
      <div>
        <Trans>Loading..</Trans>
      </div>
    );
  }

  return (
    <MobilePage>
      <AppBar />

      <section
        aria-labelledby="subject-name"
        className={classes.headerSection}
      >
        <div className={classes.newPictureSet}>
          <Trans>New picture set</Trans>
        </div>
        <Typography
          id="subject-name"
          variant="h1"
          color="primary"
          sx={{
            textAlign: "center",
            fontWeight: 300,
            color: theme.palette.primary.dark,
            fontSize: "30px",
          }}
        >
          {currentPictureSet.subject.name}
        </Typography>
        <h2 className={classes.jobName}>{currentPictureSet.job.name}</h2>
      </section>

      <Container>
        <Grid
          container
          className={classes.root}
          spacing={2}
          data-testid="picture-set-container"
        >
          {currentPictureSet.pictures.map((picture) => (
            <Grid
              key={picture.uuid}
              size={{ xs: 6, sm: 4, md: 3 }}
              className={classes.listItem}
            >
              <EpmsImage
                size={320}
                uuid={picture.uuid}
                {...getCopyrightTriggerProps()}
                onClick={(e) => openImage(e, picture)}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      <BottomBar>
        <Container>
          <Box
            display={"flex"}
            justifyContent="space-between"
            alignItems="center"
            py={1}
          >
            <div>
              <Trans>
                {{ numPictures: currentPictureSet.pictures.length }} pictures
              </Trans>
            </div>
            <NextButton pictureSet={currentPictureSet} />
          </Box>
        </Container>
      </BottomBar>

      <FullscreenImageDialog
        open={open}
        onClose={closeImage}
        transformOrigin={origin}
        picture={fullscreenImage}
      />
      {copyrightDialog}
    </MobilePage>
  );
};

const NextButton = ({ pictureSet }) => {
  if (pictureSet.qualifyForSelectOwnFavorites) {
    return (
      <Button
        component={Link}
        variant="contained"
        color="primary"
        to="/new-picture-set/favorites"
      >
        <Trans>Next</Trans>
      </Button>
    );
  }

  if (pictureSet.qualifyForSelectYearbookPose) {
    return (
      <Button
        component={Link}
        variant="contained"
        color="primary"
        to="/new-picture-set/yearbook-pose"
      >
        <Trans>Next</Trans>
      </Button>
    );
  }
  return (
    <Button
      component={Link}
      variant="contained"
      color="primary"
      to="/products/packages"
    >
      <Trans>View offers and campaigns</Trans>
    </Button>
  );
};

export default NewPictureSet;
